import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  identificationInfoData,
  updateidentificationInfoData,
} from '../store/actions/identificationVerification/identificationVerificationActions';
import useApplicationUid from './useApplicationUid';

const useIdentificationInfoDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const identifcationInfoDispatch = ({
    data,
    dates,
    onSuccess,
    defaultValues,
    onError,
  }) => {
    const {
      existingIssueDate,
      changedIssueDate,
      existingExpiryDate,
      changedExpiryDate,
    } = dates;
    const shouldSkip =
      isEqual(data, defaultValues) &&
      existingIssueDate?.toDateString() === changedIssueDate?.toDateString() &&
      existingExpiryDate?.toDateString() === changedExpiryDate?.toDateString();

    if (shouldSkip) {
      onSuccess();
      return;
    }
    const {
      IdentificationType,
      IDNumber,
      IssuedByCountry,
      IssuedByState,
    } = data;
    const requestData = {
      applicationUid: ApplicationUid,
      data: {
        IdentificationType,
        IDNumber,
        ExpirationDate: changedExpiryDate,
        IssueDate: changedIssueDate,
        IssuedByCountry,
        IssuedByState,
      },
      onSuccess,
      onError,
    };

    if (defaultValues.IdentificationType) {
      dispatch(updateidentificationInfoData({ ...requestData }));
      return;
    }
    dispatch(
      identificationInfoData({
        ...requestData,
      }),
    );
  };

  return { identifcationInfoDispatch };
};

export default useIdentificationInfoDispatch;
